import "./Header.css";
import logo from "../assets/Thryiv_logo_tm_TB.png";
import React, { useEffect, useState } from "react";
import RegisterForm from "../Pages/RegisterForm/RegisterForm";
import { FiMenu, FiX } from "react-icons/fi";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [scrolled, setScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("home");

  // ✅ Detect scroll (for header background)
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      // ✅ Activate Features tab when in section
      const featuresSection = document.querySelector("#features");
      if (featuresSection && location.pathname === "/") {
        const rect = featuresSection.getBoundingClientRect();
        const visible =
          rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2;
        setActiveTab(visible ? "features" : "home");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  // ✅ Scroll to Features
  const handleScrollToFeatures = (e) => {
    e.preventDefault();
    setActiveTab("features");
    setDrawerOpen(false);

    if (location.pathname === "/") {
      const section = document.querySelector("#features");
      if (section) section.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#features");
      setTimeout(() => {
        const section = document.querySelector("#features");
        if (section) section.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  };

  // ✅ Scroll to top (Home)
  const handleHomeClick = (e) => {
    e.preventDefault();
    setActiveTab("home");
    setDrawerOpen(false);

    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  // ✅ Contact tab
  const handleContactClick = () => {
  setActiveTab("contact");
  setDrawerOpen(false);
  navigate("/contact-us");
  window.scrollTo({ top: 0, behavior: "smooth" }); // ✅ Always scroll top
};


  // ✅ Modal
  const handleGetStartedClick = (e) => {
    e.preventDefault();
    setShowModal(true);
    setDrawerOpen(false);
  };

  const closeModal = () => setShowModal(false);
  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  // ✅ Handle location change (Contact page)
  useEffect(() => {
    if (location.pathname === "/contact-us") setActiveTab("contact");
    else if (location.hash === "#features") setActiveTab("features");
    else setActiveTab("home");
  }, [location]);

  return (
    <>
      <header
        className={`header hero-gradient ${scrolled ? "scrolled" : "transparent"}`}
      >
        <div className="logo">
          <img src={logo} alt="Thryiv logo" className="logo-img" />
        </div>

        {/* Desktop Nav */}
        <div className="desktop-nav">
          <ul className="nav-links">
            <li>
              <a
                href="/"
                onClick={handleHomeClick}
                className={activeTab === "home" ? "active-link" : ""}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="/#features"
                onClick={handleScrollToFeatures}
                className={activeTab === "features" ? "active-link" : ""}
              >
                Features
              </a>
            </li>
            <li>
              <Link
                to="/contact-us"
                onClick={handleContactClick}
                className={activeTab === "contact" ? "active-link" : ""}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>

        {/* Mobile menu icon */}
        <div className="mobile-menu-icon" onClick={toggleDrawer}>
          {drawerOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </div>
      </header>

      {/* Mobile Drawer */}
      <div className={`mobile-drawer ${drawerOpen ? "open" : ""}`}>
        <div className="drawer-close-icon" onClick={toggleDrawer}>
          <FiX size={28} />
        </div>

        <ul className="mobile-nav-links">
          <li>
            <a
              href="/"
              onClick={handleHomeClick}
              className={activeTab === "home" ? "active-link" : ""}
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#features"
              onClick={handleScrollToFeatures}
              className={activeTab === "features" ? "active-link" : ""}
            >
              Features
            </a>
          </li>
          <li>
            <Link
              to="/contact-us"
              onClick={handleContactClick}
              className={activeTab === "contact" ? "active-link" : ""}
            >
              Contact Us
            </Link>
          </li>
        </ul>

        <a href="#get-started" className="btn-get-started" onClick={handleGetStartedClick}>
          Get Started
        </a>
      </div>

      {/* Modal */}
      {showModal && <RegisterForm onClose={closeModal} />}
    </>
  );
};

export default Header;
